<template>
  <WCModal @dismiss="dismiss('Dismissed')">
    <WCModalHeader>
      <p class="font-size-lg">{{ coupon.name }}</p>
      <button class="btn btn-link underline-link-from-center" @click="dismiss('Dismissed')">
        {{ $t('close') }}
      </button>
    </WCModalHeader>
    <WCModalBody>
      <p class="wc-coupon-details-modal__details font-size-md">{{ coupon.details }}</p>
    </WCModalBody>
  </WCModal>
</template>

<script>
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import ModalMixin from '@/modules/modals/mixins/ModalMixin';

export default {
  name: 'WCCouponDetailsModal',
  mixins: [ModalMixin],
  components: { WCModal, WCModalHeader, WCModalBody },
  props: {
    coupon: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
